export default {
  title: 'Poartă de plată',
  description:
    'Propriile porți de plată pentru comenzile online. Întreaga sumă a comenzii este decontată în contul dvs. de poartă de plată; dvs. decontați cu restaurantele.',
  toasts: {
    load_error: 'Configurarea porții de plată nu a putut fi încărcată',
  },
  not_enabled: {
    title: 'Spreedly nu este activat încă pentru contul dvs.',
    description:
      'Porțile de plată locale sunt activate de FoodAmigos. Contactați reprezentantul dvs. FoodAmigos pentru a începe.',
  },
  processor_mode: {
    title: 'Cine procesează plățile?',
    description:
      'Aceasta se setează o singură dată pentru toate restaurantele tale. Poți schimba mai târziu în Setări partener, atâta timp cât niciun restaurant nu este activ.',
    save: 'Salvează',
    options: {
      platform: {
        title: 'FoodAmigos procesează plățile',
        badge: 'Recomandat',
        description:
          'Ne ocupăm de contul de plată, verificare și plăți. Fiecare restaurant adaugă datele afacerii și completează o scurtă verificare cu Adyen.',
        methods: 'Acceptate: {{methods}}',
      },
      provider: {
        title: 'Îmi aduc propriul furnizor',
        description:
          'Conectează un furnizor de plăți pe care îl folosești deja. Plățile, comisioanele și verificarea rămân la ei.',
      },
    },
    payment_methods: {
      card: 'Card',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Plată prin bancă',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos procesează plățile pentru toate restaurantele tale.',
      provider: 'Restaurantele tale acceptă plăți prin propriii furnizori.',
    },
    confirm_choice: {
      title: 'Setezi plățile pe „{{mode}}”?',
      description:
        'Aceasta se aplică tuturor restaurantelor pe care le administrezi. Poți schimba mai târziu din Setări partener, dar doar atâta timp cât niciun restaurant nu este activ.',
      confirm: 'Salvează și continuă',
    },
    switch: {
      link: 'Schimbă modul de procesare a plăților',
      confirm: {
        confirm: 'Schimbă',
        provider: {
          title: 'Treci la propriul furnizor?',
          description: 'Restaurantele care folosesc plățile FoodAmigos vor reveni la Neconfigurat.',
        },
        platform: {
          title: 'Treci la plățile FoodAmigos?',
          description: 'Restaurantele care folosesc propriii furnizori vor reveni la Neconfigurat.',
        },
      },
      unavailable: {
        title: 'Plățile FoodAmigos nu sunt încă disponibile',
        description: 'Plățile FoodAmigos nu sunt încă disponibile în țara ta.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Contactează FoodAmigos pentru a schimba acest lucru',
        description_one:
          '{{count}} restaurant încasează plăți în timp real. Trecerea la un alt furnizor ar însemna reînrolarea acestuia. Echipa noastră va planifica asta împreună cu dvs.',
        description_few:
          '{{count}} restaurante primesc plăți live. Schimbarea ar însemna că se reînscriu la noul furnizor. Echipa noastră va planifica împreună cu tine.',
        description_other:
          '{{count}} restaurante primesc plăți live. Schimbarea ar însemna reînscrierea lor cu noul furnizor. Echipa noastră va planifica asta împreună cu tine.',
        confirm: 'Trimite email către FoodAmigos',
        subject_one: 'Schimbă modul de procesare a plăților ({{count}} restaurant activ)',
        subject_few: 'Schimbă modul de procesare a plăților ({{count}} restaurante live)',
        subject_other: 'Schimbă modul de procesare a plăților ({{count}} restaurante live)',
      },
    },
    toasts: {
      load_error: 'Configurarea plăților nu a putut fi încărcată',
      save_error: 'Configurarea plăților nu a putut fi salvată',
      chosen: 'Procesarea plăților a fost salvată',
      switched: 'Procesarea plăților a fost schimbată',
    },
  },
  gateways: {
    title: 'Furnizori conectați',
    empty: 'Conectează furnizorul de plăți pe care îl folosești deja. Restaurantele tale vor fi înrolate sub el.',
    connect_another: 'Conectează un furnizor',
    support_hint:
      'Odată ce un restaurant primește plăți live, schimbarea furnizorului se planifică împreună cu noi — scrie la {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Poartă de plată',
      platform_adyen: 'Plăți FoodAmigos',
    },
    statuses: {
      connected: 'Conectat',
      disconnected: 'Deconectat',
      needs_attention: 'Necesită atenție',
    },
    issue: {
      connect_not_enabled: {
        title: 'Stripe Connect nu este activat în contul asociat cu {{name}}',
        description:
          'Stripe nu poate crea conturi pentru restaurantele tale până când Connect nu este activat. Activează-l în Stripe Dashboard, apoi verifică din nou aici.',
      },
      account_restricted: {
        title: 'Stripe blochează conturile noi create sub {{name}}',
        description:
          'Stripe ți-a restricționat temporar contul pentru crearea de conturi conectate. Autentifică-te în Stripe Dashboard, confirmă că ai intenționat să creezi aceste conturi, apoi verifică din nou aici.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe are nevoie ca {{name}} să accepte mai întâi răspunderea pentru pierderi',
        description:
          'Platforma ta Stripe nu și-a asumat încă răspunderea pentru soldurile negative din conturile restaurantelor tale, așa că Stripe nu le va crea. În Stripe Dashboard, deschide Settings → Connect → Platform profile și finalizează confirmarea răspunderii pentru pierderi, apoi verifică din nou aici. Poți ignora nota Stripe despre Accounts v2 de mai jos.',
      },
      account_creation_refused: {
        title: 'Stripe a refuzat crearea unui cont de restaurant sub {{name}}',
        description: 'Consultă mesajul de mai jos în Stripe Dashboard, apoi verifică din nou aici.',
      },
      key_invalid: {
        title: 'Stripe nu mai acceptă cheia conectată pentru {{name}}',
        description:
          'Cheia a fost schimbată, revocată sau a expirat. Creați o cheie nouă în Stripe Dashboard, apoi înlocuiți-o aici.',
      },
      key_access_limited: {
        title: 'Stripe a limitat cheia pe care ai conectat-o pentru {{name}}',
        description:
          'O cheie limitată nu poate crea transferuri sau plăți către restaurantele tale. În Stripe Dashboard, deschide Developers → API keys și restabilește accesul complet al cheii, apoi verifică din nou aici — sau regenerează cheia și înlocuiește-o aici.',
      },
      provider_said: 'Ce a spus Stripe: „{{message}}”',
      hint: 'Până când această problemă nu este rezolvată, restaurantele asociate acestui furnizor nu pot începe să primească plăți online.',
      open_stripe: 'Deschide Stripe Dashboard',
      check_again: 'Verifică din nou',
      replace_key: 'Înlocuiește cheia',
      cleared: 'Stripe a acceptat din nou restaurantele tale',
      still_blocked: 'Stripe refuză în continuare — vezi mesajul de mai sus',
    },
    refused: {
      provider_said: 'Ce a spus {{name}}: „{{message}}”',
      reference: 'Referință:',
      contact_support: 'Trimite email la suport',
      support_subject: 'Conectare furnizor de plăți refuzată: {{name}} (ref {{reference}})',
      account_in_test_mode: {
        action: 'Dezactivează Modul de Test în Authorize.Net, la {{path}}, apoi încearcă din nou.',
        open: 'Deschideți Authorize.Net',
      },
      processor_not_configured: {
        action:
          'Contactați furnizorul dvs. de servicii de plată, compania care v-a deschis contul Authorize.Net, și cereți-le să finalizeze configurarea cu procesatorul de plăți. Cheile noi nu vor rezolva acest lucru. Apoi încercați din nou.',
        action_card_connect:
          'Cereți asistenței CardConnect să activeze autorizările card-not-present (e-commerce) pentru acest ID de comerciant. Noile date de acces API nu vor schimba acest lucru. Apoi încercați din nou.',
      },
    },
    table: {
      primary_tag: 'Implicit',
      live_count_one: '{{count}} primesc plăți',
      live_count_few: '{{count}} primesc plăți',
      live_count_other: '{{count}} primesc plăți',
      attention_count_one: '{{count}} necesită atenție',
      attention_count_few: '{{count}} necesită atenție',
      attention_count_other: '{{count}} necesită atenție',
      columns: {
        connection: 'Furnizor',
        status: 'Stare',
        restaurants: 'Restaurante',
        methods: 'Metode locale',
      },
      methods_count: '{{enabled}} din {{capable}} activate',
    },
    picker: {
      recommended: 'Recomandat',
      connect: 'Conectează',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          'Folosește propriul cont Stripe. Fiecare restaurant finalizează propria înrolare Stripe; plățile și comisioanele rămân la Stripe.',
        already_connected: 'Deja conectat. Folosiți Editare credențiale din listă pentru a înlocui cheia.',
        already_connected_short: 'Deja conectat.',
      },
      stripe_direct: {
        title: 'Stripe (direct)',
        description: 'Taxează fiecare restaurant printr-un singur cont Stripe al tău.',
        unavailable: 'Nu este încă disponibil în regiunea dvs.',
      },
      paypal: {
        direct: 'Oferă PayPal din propriul cont business PayPal.',
        braintree: 'Acceptă carduri, PayPal și Venmo prin contul tău Braintree.',
      },
      other: {
        title: 'Alți furnizori',
        search: 'Căutare furnizori',
        loading: 'Se încarcă furnizorii…',
        no_match: 'Niciun furnizor numit „{{query}}”.',
        none_available: 'Nu sunt disponibili alți furnizori în regiunea dvs. încă.',
        load_error: 'Lista furnizorilor nu a putut fi încărcată.',
        retry: 'Încearcă din nou',
        pinned_match: 'Acel furnizor este fixat mai sus.',
      },
      not_listed: {
        action: 'Furnizorul meu nu este listat',
        subject: 'Solicitare furnizor de plăți: {{query}}',
      },
      use_foodamigos: {
        no_account: 'Nu am cont la niciunul dintre aceștia',
        switch: 'Comutați la plățile FoodAmigos',
      },
    },
    orchestrated: {
      title: 'Conectați {{name}}',
      replace_title: 'Înlocuiți credențialele pentru {{name}}',
      intro: 'Introduceți credențialele din contul dvs. {{name}}. Le verificăm cu {{name}} înainte de a salva ceva.',
      auth_mode: 'Cum vă autentificați la acest furnizor',
      checking: 'Se verifică cu {{name}}…',
      paypal_direct: {
        intro:
          'Inserează Client ID-ul și Secret-ul aplicației PayPal REST prin care restaurantele tale ar trebui să accepte PayPal. Le verificăm cu PayPal înainte de a salva ceva.',
        client_id: 'Client ID',
        secret: 'Secret',
        hint: 'PayPal Developer Dashboard → Apps & Credentials, pe tab-ul Live. Folosește o aplicație REST a contului tău business.',
        hint_sandbox:
          'PayPal Developer Dashboard → Apps & Credentials, în tabul Sandbox: acest mediu acceptă doar aplicații sandbox.',
      },
      braintree: {
        intro:
          'Introdu cheile API ale contului tău Braintree. PayPal și Venmo funcționează odată ce sunt conectate în Braintree Control Panel — le activezi apoi pentru fiecare conexiune.',
      },
      authorize_net: {
        intro:
          'Introduceți API Login ID și Transaction Key ale contului dvs. Authorize.Net. Le verificăm cu o mică autorizare de test: jurnalul de tranzacții Authorize.Net o va afișa ca o plată de 1,00 $ refuzată, fără mișcare efectivă de bani. Contul trebuie să fie în Modul Live, deoarece în Modul de testare Authorize.Net refuză orice plată reală.',
        hint: 'Găsești ambele în Interfața Comerciant Authorize.Net, la {{path}}.',
      },
      card_connect: {
        intro:
          'Introduceți ID-ul de comerciant, numele de utilizator și parola contului dvs. CardConnect (CardPointe) live. Le verificăm cu o autorizare de 1,00 pe care o anulăm imediat: jurnalul de tranzacții CardPointe o afișează ca 1,00 refuzat sau anulat, iar banii nu se mișcă.',
      },
      stripe_direct: {
        intro:
          'Introduceți cheia secretă a contului Stripe prin care ar trebui să fie taxat fiecare restaurant. Configurăm noi webhook-ul de care Stripe are nevoie.',
        secret_key: 'Cheie secretă Stripe',
        hint: 'Stripe → Developers → API keys. Începe cu sk_. Nu este necesară cheia publicabilă.',
        prefix_error: 'Cheile secrete Stripe încep cu sk_.',
      },
      connected: {
        title: '{{name}} este conectat.',
        description:
          'Vom folosi aceste credențiale pentru toate restaurantele dvs. Fiecare restaurant adaugă totuși propriile detalii de afaceri.',
      },
      errors: {
        generic: 'Nu am putut conecta {{name}}',
      },
    },
    stripe: {
      title: 'Conectează Stripe Connect',
      rotate_title: 'Înlocuiți cheia Stripe Connect',
      rotate_intro:
        'Lipiți o nouă cheie secretă și o cheie publicabilă din același cont Stripe. Restaurantele dvs. rămân conectate.',
      intro:
        'Lipiți cheia secretă și cheia publicabilă din contul dvs. Stripe. Ambele se află sub Developers → API keys.',
      verify_and_connect: 'Verifică și conectează',
      checking: 'Se verifică cu Stripe…',
      secret_key: {
        label: 'Cheie secretă',
        hint: 'Stripe → Developers → API keys. Începe cu sk_.',
        prefix_error: 'Cheile secrete încep cu sk_. Aceasta pare a fi un alt tip de cheie.',
      },
      restricted_key: {
        label: 'Cheie API restricționată',
        hint: 'Stripe → Developers → API keys → Create restricted key. Începe cu rk_. Configureaz-o așa cum este descris mai sus.',
        prefix_error: 'Cheile restricționate încep cu rk_. Aceasta pare a fi un alt tip de cheie.',
      },
      use_restricted_key: 'Utilizați o cheie restricționată în schimb',
      use_secret_key: 'Utilizați cheia secretă în schimb',
      publishable_key: {
        label: 'Cheie publicabilă',
        hint: 'Pe aceeași pagină Stripe. Începe cu pk_. Magazinele tale au nevoie de ea pentru a accepta carduri.',
        prefix_error: 'Cheile publicabile încep cu pk_.',
        mode_mismatch:
          'O cheie este live, iar cealaltă este de test. Ambele trebuie să provină din același mod Stripe.',
      },
      name: {
        label: 'Denumește această conexiune',
        hint: 'Opțional. Afișat oriunde este listat acest furnizor.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Cum se creează această cheie',
        start_blank:
          'Când Stripe întreabă cum vei folosi cheia, alege „{{option}}”. Aceasta pornește cu fiecare permisiune setată pe {{none}}.',
        intro:
          'Apoi setează comutatorul de pe fiecare dintre aceste rânduri de secțiune. Acesta setează toate permisiunile din secțiunea respectivă, deci nu trebuie să le parcurgi una câte una.',
        rows_checked: 'Verificăm: {{rows}}',
        secret_key_hint:
          'Lasă toate celelalte secțiuni pe {{none}}. O cheie secretă nu are nevoie de niciuna dintre acestea.',
        open_stripe: 'Deschide cheile tale API Stripe',
      },
      login_setting: {
        title: 'Dezactivați autentificarea Stripe pentru restaurantele dvs.',
        description:
          'În Stripe Dashboard, deschideți Settings → Connect → Payouts → External accounts și dezactivați „{{setting}}”. Cât timp este activată, Stripe obligă fiecare restaurant să creeze un cont Stripe cu număr de telefon în timpul înscrierii și cere un cod SMS la fiecare vizită ulterioară, astfel că cine nu are acel telefon nu poate continua.',
        bank_details: 'Nu se pierde nimic: restaurantele își introduc datele bancare în formularul nostru.',
        open_stripe: 'Deschide această setare Stripe',
      },
      errors: {
        generic: 'Stripe nu a putut fi contactat',
      },
    },
    default_choice: {
      label: 'Folosește ca implicit pentru restaurante',
      hint: 'Restaurantele noi și cele care nu au încă un furnizor sunt asociate automat cu acesta. Lasă necompletat pentru a alege tu un furnizor pentru fiecare restaurant.',
    },
    manage: {
      payment_methods: 'Metode de plată',
      edit_credentials: 'Editare credențiale',
      edit_credentials_unavailable: 'Editați datele de conectare (acest furnizor nu este disponibil momentan)',
      set_primary: 'Setează ca implicit pentru restaurante noi',
      clear_primary: 'Nu mai folosi ca implicit pentru restaurante noi',
      rename: {
        action: 'Redenumește conexiunea',
        title: 'Redenumește această conexiune',
        confirm: 'Salvează',
      },
      disconnect: {
        action: 'Deconectează',
        title: 'Deconectezi {{name}}?',
        confirm: 'Deconectează',
        warning_one: '{{count}} restaurant este asociat cu acesta și va reveni la Neconfigurat.',
        warning_few: '{{count}} restaurante sunt asociate cu el și vor reveni la Neconfigurat.',
        warning_other: '{{count}} restaurante sunt asociate cu acesta și vor reveni la Neconfigurat.',
        live: {
          title_one: 'Plățile online se opresc pentru {{count}} restaurant activ',
          title_few: 'Plățile online se opresc pentru {{count}} restaurante active',
          title_other: 'Plățile online se opresc pentru {{count}} restaurante active',
          description:
            'Imediat ce îl deconectezi, clienții lor nu mai pot plăti online. Fiecare restaurant revine la Neconfigurat până când îl asociezi cu alt furnizor.',
          refunds: 'Comenzile deja plătite prin acest furnizor nu mai pot fi rambursate din FoodAmigos.',
          pause_one: 'Întrerupeți plățile online pentru acest restaurant',
          pause_few: 'Întrerupeți plățile online pentru aceste {{count}} restaurante',
          pause_other: 'Întrerupeți plățile online pentru aceste {{count}} restaurante',
          confirm: 'Deconectează și oprește plățile',
        },
      },
      remove: {
        action: 'Elimină din listă',
        title: 'Elimini {{name}}?',
        description: 'Este deja deconectat și niciun restaurant nu îl folosește. Nu va mai apărea în această listă.',
        confirm: 'Elimină',
      },
    },
    payment_methods: {
      title: 'Metode de plată pentru {{name}}',
      description:
        'Alege metodele locale pe care restaurantele tale le oferă prin acest furnizor. Fiecare apare doar unde valuta restaurantului corespunde.',
      save: 'Salvează',
      publishable_key: {
        label: 'Cheie publicabilă Stripe',
        hint: 'Stripe are nevoie de ea pentru a afișa formularul de plată. O găsești în Stripe Dashboard, la Developers → API keys.',
        invalid: 'O cheie publicabilă începe aici cu {{prefix}}.',
        clear_to_save: 'Aparține celuilalt mod Stripe. Șterge-l pentru a salva cu toate metodele locale dezactivate.',
      },
      on_other_connection: 'deja activat pentru {{connection}}',
      other_currency: 'nu este disponibil în {{currency}}',
      delivery_only: '{{name}} (doar pentru comenzi cu livrare — necesită adresa clientului)',
      invite_only:
        '{{name}} (Stripe oferă acest lucru doar pe bază de invitație — solicitați mai întâi accesul în contul dvs. Stripe, altfel Stripe refuză fiecare plată)',
      also_enable: {
        stripe:
          'Activează aceleași metode în Stripe Dashboard, la Settings → Payment methods, altfel Stripe le refuză.',
        provider: 'Contractul tău cu acest furnizor trebuie să includă metodele pe care le activezi aici.',
        braintree:
          'Conectează PayPal și Venmo în Braintree Control Panel la Settings → Processing mai întâi, altfel Braintree le refuză. Venmo este pentru restaurantele din SUA care taxează în dolari.',
        paypal_direct:
          'Plățile PayPal sunt încasate în acest cont business PayPal. Pentru Venmo, conectează Braintree.',
      },
    },
    actions: {
      cancel: 'Anulează',
    },
    toasts: {
      load_error: 'Nu s-au putut încărca furnizorii conectați',
      credentials_replaced: 'Credențiale înlocuite',
      save_error: 'Salvarea a eșuat',
      connected: 'Stripe Connect este conectat',
      renamed: 'Conexiune redenumită',
      primary_set: 'Furnizorul implicit a fost actualizat',
      primary_cleared:
        'Furnizorul implicit a fost eliminat. Restaurantele noi nu sunt asociate cu niciun furnizor până când alegi unul.',
      disconnected: 'Furnizor deconectat',
      removed: 'Furnizor eliminat',
      payment_methods_saved: 'Metodele de plată au fost salvate',
    },
  },
  restaurants: {
    title: 'Restaurante',
    description: 'Situația fiecărui restaurant în privința plăților online.',
    search: 'Caută restaurante',
    filters: {
      all: 'Toate ({{count}})',
      needs_attention: 'Necesită atenție ({{count}})',
    },
    empty: 'Niciun restaurant încă.',
    empty_attention: 'Nimic nu necesită atenția ta.',
    columns: {
      restaurant: 'Restaurant',
      provider: 'Furnizor',
      status: 'Stare',
      action: 'Acțiune',
    },
    no_provider: '—',
    foodamigos_payments: 'Plăți FoodAmigos',
    groups: {
      not_set_up: 'Neconfigurat',
      business_details_missing: 'Detalii afacere lipsă',
      hosted_not_finished: 'Formularul {{provider}} nefinalizat',
      hosted_not_finished_generic: 'Formularul furnizorului nefinalizat',
      waiting_for_provider: 'Se așteaptă furnizorul',
      action_needed: 'Necesită acțiune',
      payments_live: 'Plăți active',
      online_payments_off: 'Plăți online dezactivate',
      waiting_for_partner: 'Se așteaptă răspunsul tău',
    },
    link_expired: 'Link expirat',
    actions: {
      set_up: 'Configurează',
      change: 'Schimbă',
      unlink: 'Dezleagă',
      remind: 'Reamintește proprietarului',
      reminded: 'Reamintit · din nou {{time}}',
    },
    assign: {
      title: 'Ce furnizor ar trebui să folosească {{name}}?',
      label: 'Furnizor',
      confirm: 'Salvează',
      cancel: 'Anulează',
      primary: 'Implicit',
      none: 'Conectează mai întâi un furnizor.',
    },
    unlink: {
      title: 'Dezleagi {{name}} de {{provider}}?',
      title_generic: 'Dezlegați {{name}} de furnizorul său?',
      description:
        'Restaurantul revine la „Neconfigurat”, astfel încât să poți alege furnizorul potrivit pentru el. Furnizorul rămâne conectat pentru celelalte restaurante ale tale.',
      confirm: 'Dezleagă',
    },
    pause: {
      title: 'Plățile online sunt suspendate pentru {{name}}',
      description:
        'Clienții săi nu mai pot plăti online până când restaurantul este configurat și verificat din nou cu un furnizor.',
      refunds: 'Comenzile deja plătite prin furnizorul actual nu mai pot fi rambursate din FoodAmigos.',
      confirm: 'Întrerupeți plățile online pentru acest restaurant',
    },
    toasts: {
      load_error: 'Nu s-au putut încărca restaurantele tale',
      assigned: 'Furnizor salvat',
      assign_error: 'Nu s-a putut salva furnizorul',
      unlinked: 'Restaurant dezlegat',
      unlink_error: 'Dezlegarea restaurantului a eșuat',
      reminded: 'Memento trimis proprietarului',
      remind_error: 'Nu s-a putut trimite mementoul',
      cooling_down: 'Proprietarul a fost deja anunțat astăzi',
    },
  },
  footer: {
    text: 'Comisionul tău de serviciu FoodAmigos ți se facturează indiferent de furnizorul folosit de un restaurant.',
    link: 'Vezi Facturare',
  },
};
